import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";

const Integrations = () => {
  const navigate = useNavigate();

  const integrationCards = [
    {
      id: "freshchat",
      title: "Freshchat",
      description: "Omni-channel customer support & live chat",
      icon: <img src="/freshchat.png" alt="Freshchat" className="w-16 h-16 object-contain" />,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
      route: "/freshchat-config",
    },
    {
      id: "freshdesk",
      title: "Freshdesk",
      description: "Customer service software & support ticket system",
      icon: <img src="/freshdesk.png" alt="Freshdesk" className="w-16 h-16 object-contain" />,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
      route: "/freshdesk-config",
    },
    {
      id: "telegram",
      title: "Telegram",
      description: "High-speed bot integration for instant messaging",
      icon: (
        <svg className="w-16 h-16 text-[#0088cc]" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>
      ),
      color: "text-blue-500",
      bgColor: "bg-blue-50",
      route: "/telegram-config",
    },
    {
      id: "slack",
      title: "Slack",
      description: "Collaborative AI responses for your workspaces",
      icon: <img src="/slack.svg" alt="Slack" className="w-16 h-16 object-contain" />,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
      route: "/slack-config",
    },
    {
      id: "whatsapp",
      title: "WhatsApp",
      description: "Engage users on the world's most popular app",
      icon: (
        <svg className="w-16 h-16 text-[#25D366]" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      ),
      color: "text-blue-500",
      bgColor: "bg-blue-50",
      route: "/whatsapp-config",
      comingSoon: false,
    },
    {
      id: "email",
      title: "Email",
      description: "Automate outbound communications and email workflows.",
      icon: <img src="/gmail.png" alt="Gmail" className="w-16 h-16 object-contain" />,
      color: "text-gray-900",
      bgColor: "bg-gray-50",
      route: "/email-config",
    },
    {
      id: "zendesk",
      title: "Zendesk",
      description: "Sync AI agent intelligence directly with your Zendesk Support Ticket system.",
      icon: <img src="/zendesk.png" alt="Zendesk" className="w-16 h-16 object-contain" />,
      color: "text-[#03363D]",
      bgColor: "bg-[#03363D]/5",
      route: "/zendesk-config",
    },
    {
      id: "shopify",
      title: "Shopify",
      description: "Automate customer order tracking, product lookup, and e-commerce support.",
      icon: <img src="/shopify.png" alt="Shopify" className="w-16 h-16 object-contain" />,
      color: "text-[#5E8E3E]",
      bgColor: "bg-[#95BF47]/10",
      route: "/shopify-config",
    },
  ];

  const handleCardClick = (route, comingSoon) => {
    if (comingSoon) return;
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-[#FDFCFD] pt-4 pb-8 px-8 lg:pt-6 lg:pb-12 lg:px-12 animate-fadeIn flex justify-center items-start border-t border-gray-100">
      <div className="w-full max-w-7xl space-y-20">
        <PageHeader 
          title="Neural Bridge"
          description="Harmonize your agentic intelligence with the global software ecosystem."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 animate-slideIn pb-20">
          {integrationCards.map((card) => (
            <button
              key={card.id}
              onClick={() => handleCardClick(card.route, card.comingSoon)}
              disabled={card.comingSoon}
              className={`
                group relative bg-white rounded-[40px] p-10 border border-gray-100 
                transition-all duration-500 hover:shadow-2xl hover:shadow-gray-200/50 hover:-translate-y-2
                flex flex-col items-center text-center gap-8 overflow-hidden
                ${card.comingSoon ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
              `}
            >
              <div className="transition-transform duration-500 group-hover:scale-110">
                {card.icon}
              </div>
              
              <div className="space-y-3">
                <h3 className="text-2xl font-black text-gray-900 tracking-tight">
                  {card.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed px-2 font-medium">
                  {card.description}
                </p>
              </div>

              {!card.comingSoon ? (
                <div className="mt-2 px-8 py-3 bg-gray-900 text-white rounded-2xl text-xs font-bold tracking-widest uppercase opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                  Configure
                </div>
              ) : (
                <div className="mt-2 px-8 py-3 bg-gray-100 text-gray-400 rounded-2xl text-[10px] font-bold tracking-widest uppercase">
                  Coming Soon
                </div>
              )}

              {/* Neural Decorative Element */}
              <div className="absolute -bottom-16 -right-16 w-40 h-40 bg-gray-50/50 rounded-full group-hover:scale-150 transition-transform duration-1000 -z-10"></div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Integrations;
